import { createContext, useContext } from "react";

export const DialogContext = createContext(() => {});
export const useDialogs = () => useContext(DialogContext);
